import './especial_card_menu.sass'

function EspecialCardMenu({ children, title, containerClasses }) {
  return (
    <div className='special-card-menu-wrapper'>
      <div className='special-card-menu-header br-top-6'>
        <h3>{title}</h3>
      </div>
      <div className={`content ${containerClasses}`}>
        {children}
      </div>
    </div>
  )
}

export default EspecialCardMenu
